<!--心理咨询中心-->
<template>
  <div class="vantWrapper">
    <!--视频正在上传中-->
    <template v-if="status===0">
      <div class="content van-content" style="height:100%">
        <div class="titleWrapper" >
          <h4 class="nameFont">{{name}}</h4>
          <div class="addrFont">{{did}}</div>
          <div class="addrFont" @click.stop="openApp"><van-icon color="red" style="margin-right:5px;" name="map-marked" />{{addr?addr:'暂时无法获取位置'}}</div>
        </div>
        <van-divider />
        <div>
          <van-empty style="height:100%" description="视频正在上传中..." />
        </div>
      </div>
    </template>
    <!--只有图片-->
    <template v-else-if="status===1">
      <div class="content van-content" style="height:100%">
        <div class="titleWrapper" >
          <h4 class="nameFont">{{name}}</h4>
          <div class="addrFont">{{did}}</div>
          <div class="addrFont" @click.stop="openApp"><van-icon color="red" style="margin-right:5px;" name="map-marked" />{{addr?addr:'暂时无法获取位置'}}</div>
        </div>
        <van-divider />
        <div>
          <template v-for="(item,index) in img">
            <van-image
            class="listConten"
            :key="index"
            width="100%"
            fit="contain"
            lazy-load
            :src="item"
            @click="clickImg(item,index)"
          />
          </template>
        </div>
      </div>
    </template>
    <!--图片视频都有-->
    <template v-else-if="status===2">
      <div class="content titleWrapper" style="padding-bottom:0">
        <h4 class="nameFont">{{name}}</h4>
        <div class="addrFont">{{did}}</div>
        <div class="addrFont" @click.stop="openApp"><van-icon color="red" style="margin-right:5px;" name="map-marked" />{{addr?addr:'暂时无法获取位置'}}</div>
      </div>
      <van-divider />
      <div class="content">
        <div v-for="(item,index) in url" :key="index" class="listConten">
          <video controls="controls" style="object-fit:cover;width:100%" class="video" :ref="'video'+index" :id="'video'+index" :src="item.src" :poster="item.poster">
          </video>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content van-content" style="height:100%">
        <div class="titleWrapper" >
          <h4 class="nameFont">{{name}}</h4>
          <div class="addrFont">{{did}}</div>
          <div class="addrFont" @click.stop="openApp"><van-icon color="red" style="margin-right:5px;" name="map-marked" />{{addr?addr:'暂时无法获取位置'}}</div>
        </div>
        <van-divider />
        <div>
          <van-empty style="height:100%" description="视频丢失" />
        </div>
      </div>
    </template>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" title="打开方式" />
  </div>
</template>
<script>
import {commonUtil} from '@/views/mixins/common'
import {GpsGetSOS} from '@/api/sos'
import { ImagePreview } from 'vant';
export default {
  mixins:[commonUtil],
  data(){
    return{
      old_id:null,
      token:null,
      name:null,
      did:null,
      addr:null,
      lng:null,
      lat:null,
      status:null,
      img:[],
      url:[],
      show:false,
      actions:[
        {
          name:'百度地图',
          id:1
        },
        {
          name:'高德地图',
          id:2
        },
        {
          name:'谷歌地图',
          id:3
        }
      ]
    }
  },
  components: {
    
  },
  computed:{
    
  },
  methods:{
    videoOper(){
      let vm=this;
      this.$nextTick(()=>{
        let elVide=document.getElementsByClassName('video')
        for(let i=0;i<elVide.length;i++){
          elVide[i].addEventListener('play', function (e) { //播放开始执行的函数
              vm.changePlay(e)
          });
        }
        
      })
    },
    //播放当前视频，上个视频暂停播放
    changePlay(e) {
      let idx = e.target.id ? e.target.id : e.target.dataset.id;
      let newVis = document.getElementById(idx);
      //判断新的视频和当前视频是否相等
      if (this.old_id == idx || this.old_id===null) {
        newVis.volume=0.1
        newVis.muted=false
      } else {
        if (this.old_id && document.getElementById(this.old_id)) {
          // document.getElementById(this.old_id).pause()
          document.getElementById(this.old_id).muted=true
          // document.getElementById(this.old_id).muted=document.getElementById(this.old_id).volume
        }
      }
      this.old_id = idx;
    },
    clickImg(img,index){
      ImagePreview({
        images:this.img,
        startPosition:index
      })
    },
    initParams(){
      let params=this.$route.params;
      if(params.token){
        this.token=params.token
      }
    },
    init(){
      this.img.splice(0)
      this.url.splice(0)
      this.$store.commit('showToast')
      GpsGetSOS({token:this.token}).then(res=>{
        this.$store.commit('closeToast')
        console.log(res)
       if (res) {
          try {
            this.status=res.status
            if(res.status===1){
              let info=res.infoList;
              for(let i in info){
                this.img.push(info[i].imgUrl)
              }
            }else if(res.status===2){
              let info=res.infoList;
              for(let i in info){
                this.url.push({
                  src:info[i].videoUrl,
                  poster:info[i].imgUrl
                })
              }
            }
            this.name=res.name
            this.addr=res.addr
            this.did=res.did
            this.lat=res.lat
            this.lng=res.lng
            this.videoOper()
          } catch (err) {
            //this.$store.commit('closeToast')
          }
        }else{
          this.$toast.fail({duration:0,message:'现场视频记录失效'})
        }
      })
    },
    isIOS(){
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      return isiOS
    },
    openApp(){
      if(this.lat && this.lng){
        this.show=true;
      }
    },
    onSelect(item){
      if(item.id===1){
        this.goBaidu(this.lat,this.lng,this.addr)
      }else if(item.id===2){
        this.gogaode(this.lat,this.lng,this.addr)
      }else if(item.id===3){
        //this.goGoogle(29.539792,106.519852,'123')
        this.goGoogle(this.lat,this.lng,this.addr)
      }
    },
    goBaidu(lat,lng,addr){
      var latCurrent = lat; //获取到的纬度
      var lngCurrent = lng; //获取到的经度
      var scheme = '';
      var queryStr='?location=' + latCurrent + ',' + lngCurrent + '&title=位置&content='+addr+'&src='
      if (this.isIOS()) {
        // ios 端
        queryStr=queryStr+'ios.baidu.openAPIdemo'
        scheme = 'baidumap://map/marker' + queryStr;
      } else {
        // android 端
        queryStr=queryStr+'andr.baidu.openAPIdemo'
        scheme = 'bdapp://map/marker' + queryStr;
      }

      // 主要实现代码
      window.location.href = scheme;
      var startTime = Date.now();
      var count = 0;
      var endTime = 0;
      var t = setInterval(function () {
        count += 1;
        endTime = Date.now() - startTime;
        if (endTime > 800) {
          clearInterval(t);
        }
        if (count < 30) return;
        if (!(document.hidden || document.webkitHidden)) {
          window.location.href = scheme
        }
      }, 20);
      window.onblur = function () {
        clearInterval(t);
      }
    },
    goGoogle(lat,lng,addr){
      var scheme = '';
      if (this.isIOS()) {
        scheme = 'comgooglemaps://?q=@'+lat+','+lng+'&zoom=16&addr='+addr
      } else {
        scheme = 'geo:0,0?q='+lat+','+lng
      }

      // 主要实现代码
      window.location.href = scheme;
      var startTime = Date.now();
      var count = 0;
      var endTime = 0;
      var t = setInterval(function () {
        count += 1;
        endTime = Date.now() - startTime;
        if (endTime > 800) {
          clearInterval(t);
        }
        if (count < 30) return;
        if (!(document.hidden || document.webkitHidden)) {
          window.location.href = scheme
        }
      }, 20);
      window.onblur = function () {
        clearInterval(t);
      }
    },
    gogaode(lat,lng,addr){
      var scheme = '';
      var queryStr='?sourceApplication=appname&poiname='+addr+'&lat='+lat+'&lon='+lng+'&dev=0'
      if (this.isIOS()) {
        // ios 端
        //queryStr=queryStr+'ios.baidu.openAPIdemo'
        scheme = 'iosamap://viewMap' + queryStr;
      } else {
        // android 端
        //queryStr=queryStr+'andr.baidu.openAPIdemo'
        scheme = 'androidamap://viewMap' + queryStr;
      }

      // 主要实现代码
      window.location.href = scheme;
      var startTime = Date.now();
      var count = 0;
      var endTime = 0;
      var t = setInterval(function () {
        count += 1;
        endTime = Date.now() - startTime;
        if (endTime > 800) {
          clearInterval(t);
        }
        if (count < 30) return;
        if (!(document.hidden || document.webkitHidden)) {
          window.location.href = scheme
        }
      }, 20);
      window.onblur = function () {
        clearInterval(t);
      }
    }
  },
  mounted(){
    this.initParams()
    this.init()
    // this.videoOper()
  }
}
</script>
<style scoped>
.gradInner{
  margin:0 auto;
}
.gradWrapper{
  padding:10px;
  display: grid;
  grid-template-columns: repeat(2, calc(50vw - 18px));
  grid-template-rows: repeat(2, calc(50vw - 18px));
  grid-gap:16px;
  margin:0 auto;
}
.gradClass{
  border-radius:10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
.van-grid{
  margin-top:10px;
}
.vantInner{
  display: flex;
  flex-direction: column;
  height: 100%;
}
.vantFlex{
  display: flex;
  flex-direction: column;
  flex:1;
  justify-content: space-between;
}
.bottomMess{
  margin-bottom:16px;
}
.bottomCenter{
  text-align: center;
  color:rgb(243, 63, 63);
}
.bottomRecord{
  padding:16px;
}
.iconfont{
  font-size: 60px;
  color:rgb(30, 114, 210)
}
.vantWrapper{
  width:100%;
  height:100%
}
.liveView {
  position: relative;
  min-height:500px
}
.vjs-custom-skin .video-js{
  height: 500px
}
.vjs-custom-skin .video-js .vjs-tech{
  height: 500px
}
.titleWrapper{
  position: relative;
}
.nameFont{
  font-size: 20px;
}
.content{
  padding:16px;
  box-sizing: border-box;
}
.addrFont{
  font-size: 18px;
}
.van-content{
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; 
}
.listConten{
  margin-bottom:8px;
}
.rvideos-item{
  position: relative;
  width:100%;
  height:100%;
}
.video-icon{
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  width: 50px;
  height: 50px;
  margin:auto;
}
</style>